import { Link } from 'react-router-dom';
import { Card, Badge } from '@bbpos/ui';

interface ActiveBillsWidgetProps {
  count: number;
}

export function ActiveBillsWidget({ count }: ActiveBillsWidgetProps) {
  return (
    <Card className="p-4 shadow-md backdrop-blur-sm bg-white/80 dark:bg-neutral-900/80 transition-all duration-200 hover:shadow-lg animate-slide-up">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-violet-500 to-pink-500 flex items-center justify-center text-white">
            <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h3 className="text-sm font-semibold text-neutral-700 dark:text-neutral-200">
            Active Bills
          </h3>
        </div>
        <Badge variant="info">{count}</Badge>
      </div>

      {count === 0 ? (
        <p className="text-xs text-neutral-400 dark:text-neutral-500">No active bills right now</p>
      ) : (
        <>
          <p className="text-2xl font-bold tabular-nums text-neutral-900 dark:text-neutral-100 mb-1">{count}</p>
          <p className="text-xs text-neutral-500 dark:text-neutral-400">
            bill{count !== 1 ? 's' : ''} parked or in draft
          </p>
          {/* The list filters one status at a time, so one link per status. */}
          <div className="mt-3 flex gap-4">
            <Link
              to="/bills?status=PARKED"
              className="text-sm font-medium text-brand-600 dark:text-brand-400 hover:underline transition-colors"
            >
              Parked &rarr;
            </Link>
            <Link
              to="/bills?status=DRAFT"
              className="text-sm font-medium text-brand-600 dark:text-brand-400 hover:underline transition-colors"
            >
              Drafts &rarr;
            </Link>
          </div>
        </>
      )}
    </Card>
  );
}
